import { render } from "./ArchiveGroupReportModal.vue?vue&type=template&id=0f406cc6"
import script from "./ArchiveGroupReportModal.vue?vue&type=script&lang=js"
export * from "./ArchiveGroupReportModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__